import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { authClient } from '../../api/auth';
import styles from '../../styles/Profile.module.css';
export function ProfilePage() {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [name, setName] = useState('');
    const [nameStatus, setNameStatus] = useState(null);
    const [nameSaving, setNameSaving] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordStatus, setPasswordStatus] = useState(null);
    const [passwordSaving, setPasswordSaving] = useState(false);
    useEffect(() => {
        fetch('/api/profile', { credentials: 'include' })
            .then(res => res.json())
            .then((data) => {
            setProfile(data);
            setName(data.name);
            setLoading(false);
        })
            .catch(() => setLoading(false));
    }, []);
    const handleNameSubmit = async (e) => {
        e.preventDefault();
        setNameStatus(null);
        setNameSaving(true);
        try {
            const result = await authClient.updateUser({ name });
            if (result.error) {
                setNameStatus({ type: 'error', text: result.error.message || 'Ошибка обновления имени' });
            }
            else {
                setNameStatus({ type: 'success', text: 'Имя обновлено' });
            }
        }
        catch {
            setNameStatus({ type: 'error', text: 'Ошибка соединения с сервером' });
        }
        setNameSaving(false);
    };
    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setPasswordStatus(null);
        if (newPassword !== confirmPassword) {
            setPasswordStatus({ type: 'error', text: 'Пароли не совпадают' });
            return;
        }
        if (newPassword.length < 8) {
            setPasswordStatus({ type: 'error', text: 'Новый пароль должен быть не менее 8 символов' });
            return;
        }
        setPasswordSaving(true);
        try {
            const result = await authClient.changePassword({
                currentPassword,
                newPassword,
                revokeOtherSessions: false,
            });
            if (result.error) {
                const msg = result.error.code === 'INVALID_PASSWORD'
                    ? 'Неверный текущий пароль'
                    : (result.error.message || 'Ошибка смены пароля');
                setPasswordStatus({ type: 'error', text: msg });
            }
            else {
                setPasswordStatus({ type: 'success', text: 'Пароль изменён' });
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            }
        }
        catch {
            setPasswordStatus({ type: 'error', text: 'Ошибка соединения с сервером' });
        }
        setPasswordSaving(false);
    };
    if (loading) {
        return _jsx("div", { style: { textAlign: 'center', padding: '2rem', color: '#808090' }, children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." });
    }
    return (_jsx("div", { className: styles.container, children: _jsxs("div", { className: styles.content, children: [_jsx("h1", { className: styles.title, children: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C" }), profile && (_jsx("div", { className: styles.section, children: _jsxs("div", { className: styles.info, children: [profile.email, " \u00B7 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D ", new Date(profile.createdAt).toLocaleDateString('ru-RU')] }) })), _jsxs("div", { className: styles.section, children: [_jsx("h2", { className: styles.sectionTitle, children: "\u0418\u043C\u044F" }), _jsxs("form", { onSubmit: handleNameSubmit, className: styles.form, children: [_jsxs("label", { className: styles.label, children: ["\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u043E\u0435 \u0438\u043C\u044F", _jsx("input", { type: "text", value: name, onChange: (e) => setName(e.target.value), className: styles.input, required: true, "data-testid": "profile-name-input" })] }), nameStatus && (_jsx("div", { className: nameStatus.type === 'success' ? styles.success : styles.error, children: nameStatus.text })), _jsx("button", { type: "submit", className: styles.button, disabled: nameSaving, "data-testid": "profile-name-save", children: nameSaving ? 'Сохранение...' : 'Сохранить имя' })] })] }), _jsxs("div", { className: styles.section, children: [_jsx("h2", { className: styles.sectionTitle, children: "\u0421\u043C\u0435\u043D\u0430 \u043F\u0430\u0440\u043E\u043B\u044F" }), _jsxs("form", { onSubmit: handlePasswordSubmit, className: styles.form, children: [_jsxs("label", { className: styles.label, children: ["\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", _jsx("input", { type: "password", value: currentPassword, onChange: (e) => setCurrentPassword(e.target.value), className: styles.input, required: true, "data-testid": "profile-current-password" })] }), _jsxs("label", { className: styles.label, children: ["\u041D\u043E\u0432\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C", _jsx("input", { type: "password", value: newPassword, onChange: (e) => setNewPassword(e.target.value), className: styles.input, required: true, minLength: 8, "data-testid": "profile-new-password" })] }), _jsxs("label", { className: styles.label, children: ["\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", _jsx("input", { type: "password", value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value), className: styles.input, required: true, minLength: 8, "data-testid": "profile-confirm-password" })] }), passwordStatus && (_jsx("div", { className: passwordStatus.type === 'success' ? styles.success : styles.error, children: passwordStatus.text })), _jsx("button", { type: "submit", className: styles.button, disabled: passwordSaving, "data-testid": "profile-password-save", children: passwordSaving ? 'Сохранение...' : 'Сменить пароль' })] })] })] }) }));
}
